import type { PlaywrightEnv } from "../../@types/playwright";

export const playwrightEnv: PlaywrightEnv = window?.playwright ?? {
  DISABLE_IDLE_TIMEOUT: false,
  DISABLE_REACT_QUERY_DEVTOOLS: false,
};
